import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CorporateIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CorporateIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.5211 20.6963H4.47909C3.11239 20.6963 2.00009 19.584 2.00009 18.2168V9.32227C2.00009 7.95557 3.11239 6.84327 4.47909 6.84327H19.5211C20.8878 6.84327 22.0001 7.95557 22.0001 9.32227V18.2168C22.0001 19.584 20.8878 20.6963 19.5211 20.6963ZM4.47909 7.84326C3.66366 7.84326 3.00009 8.50683 3.00009 9.32226V18.2168C3.00009 19.0327 3.66366 19.6963 4.47909 19.6963H19.5211C20.3365 19.6963 21.0001 19.0327 21.0001 18.2168V9.32226C21.0001 8.50683 20.3365 7.84326 19.5211 7.84326H4.47909Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.0982 10.1714C15.8219 10.1714 15.5982 9.94775 15.5982 9.67138V5.7832C15.5982 4.96728 14.9347 4.30371 14.1192 4.30371H9.88144C9.06552 4.30371 8.40195 4.96728 8.40195 5.7832V9.67138C8.40195 9.94775 8.17832 10.1714 7.90195 10.1714C7.62558 10.1714 7.40195 9.94775 7.40195 9.67138V5.7832C7.40195 4.41601 8.51425 3.30371 9.88144 3.30371H14.1192C15.4859 3.30371 16.5982 4.41601 16.5982 5.7832V9.67138C16.5982 9.94775 16.3746 10.1714 16.0982 10.1714Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0001 13.2451C8.32089 13.2451 4.87802 12.6494 2.30624 11.5684C2.05185 11.4614 1.93222 11.168 2.03915 10.9136C2.14657 10.6582 2.44003 10.541 2.69394 10.6465C5.1456 11.6772 8.45078 12.2451 12.0001 12.2451C15.5489 12.2451 18.8541 11.6772 21.3062 10.6465C21.5592 10.541 21.8536 10.6582 21.961 10.9136C22.068 11.1685 21.9483 11.4614 21.6939 11.5684C19.1217 12.6494 15.6788 13.2451 12.0001 13.2451Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.0489 16.8774H9.95126C9.67489 16.8774 9.45126 16.6538 9.45126 16.3774C9.45126 16.1011 9.67489 15.8774 9.95126 15.8774H14.0489C14.3253 15.8774 14.5489 16.1011 14.5489 16.3774C14.5489 16.6538 14.3253 16.8774 14.0489 16.8774Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CorporateIcon;
